import { memo } from 'react'

import { addProductToCart } from '@/store/slices/cart'
import Product from '@/ts/Product'

import AddToCartButton from '../AddToCartButton'
import FansiClass from './includes/FansiClass'
import FansiCollection from './includes/FansiCollection'
import FansiVideo from './includes/FansiVideo'

function Body({ product }: BodyProps) {
  if (product.type === 'Product::FansiClass') {
    return <FansiClass product={product} />
  }

  if (product.type === 'Product::FansiCollection') {
    return <FansiCollection product={product} />
  }

  if (product.type === 'Product::FansiVideo') {
    return <FansiVideo product={product} />
  }

  return (
    <div className="flex flex-col space-y-3">
      {product?.status === 'active' && (
        <AddToCartButton onClick={() => addProductToCart(product)} />
      )}
      {product?.voucher_enabled && (
        <AddToCartButton
          onClick={() => addProductToCart({ ...product, gift: true })}
          className="text-sbtviolet-550 !bg-sbtviolet-200 hover:bg-sbtviolet-250 hover:text-white"
          text={'Kup jako prezent'}
          icon="surprise"
        />
      )}
    </div>
  )
}

interface BodyProps {
  product: Product
}

export default memo(Body)
